module.exports = __webpack_public_path__ + "static/img/mainland.4b6b190c.png";